export default __webpack_public_path__ + "static/YrsaRegular-cdfc31b204871f8d17c6cc92d5fbfbe0.woff2";